import $ from 'jquery';
import './../lib/jquery/jquery.fittext-local.js';
import {Numbers} from "./numberFormatter.es6";

const scrollIntoViewLib = require('scroll-into-view');
const log = console.log;
// const log = noop;

const MONTH_DAYS = 30;
const DAY_SECONDS = 60 * 60 * 24;
const HOUR_SECONDS = 60 * 60;

export function noop() {
}

export function randomInt(endExclusive) {
    return Math.floor(Math.random() * endExclusive);
}

export function randomOf(...values) {
    return values[randomInt(values.length)];
}

export function randomOfArray(array) {
    return array[randomInt(array.length)];
}

export function randomBool() {
    return Math.random() >= 0.5;
}

export function swapInArray(a, from, to) {
    const x = a[from];
    a[from] = a[to];
    a[to] = x;
}

export function shuffleArray(a) {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        swapInArray(a, i - 1, j);
    }
}

export function fitText(textJq, heightMinSpace) {
    textJq.fitText({minFontSize: '12px', maxFontSize: '35px', heightMinSpace: heightMinSpace});
}

function fitContentImageIfNeeded(jqimg) {
    jqimg.fitImage({show: true});
}

function fitContentTextIfNeeded(jqp) {
    if (jqp.is(':visible')) {
        fitText(jqp);
    }
}

export function fitContent(container) {
    fitContentImageIfNeeded(container.find('img[fitimage]'));
    fitContentImageIfNeeded(container.find('img[data-fitimage]'));
    fitContentTextIfNeeded(container.find('p[fittext], div[fittext]'));
    fitContentTextIfNeeded(container.find('p[data-fittext], div[data-fittext]'));
}

const TRIM_WHITESPACE = /\s+/g;
const TRIM_PUNCTUATION = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]/g;

function simplifyForComparison(text) {
    return text
        .replace(TRIM_WHITESPACE, '')
        .replace(TRIM_PUNCTUATION, '')
        .toLocaleLowerCase();
}

/**
 * @param {string} expected
 * @param {string} userText
 * @param {boolean} [onlyFullMatch] если true - то принимается только full match, инача достаточно попасть в один елемент из списка, разделенный запятыми
 * @return {boolean}
 */
export function checkWrittenAnswer(expected, userText, onlyFullMatch = false) {
    expected = expected.toLocaleLowerCase();
    userText = userText.toLocaleLowerCase();

    // проверяем полное совпадение
    const fullMatch = simplifyForComparison(userText) === simplifyForComparison(expected);
    if (onlyFullMatch || fullMatch) {
        return fullMatch;
    }

    const partsDelimiter = /[,/;]/;

    const expectedParts = expected.split(partsDelimiter).map(item => simplifyForComparison(item)).filter(item => item.length > 0);
    const userTextParts = userText.split(partsDelimiter).map(item => simplifyForComparison(item)).filter(item => item.length > 0);

    const expectedPartsFound = expectedParts.filter(userTextPart => {
        return userTextParts.some(expectedPart => expectedPart === userTextPart)
    });

    if (onlyFullMatch) {
        return expectedPartsFound.length === expectedParts.length;
    }

    return expectedPartsFound.length > 0;
}

export function parseBoolean(text) {
    switch (String(text)) {
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
}

export function scrollIntoView(el) {
    scrollIntoViewLib($(el).get(0), {
        time: 1000,
        align: {
            top: 0.1
        },
        ease: function (value) {
            return 1 - Math.pow(1 - value, value / 5);
        }
    });
}

export function isEnterEvent(e) {
    return e.which === 13 || e.keyCode === 13;
}

export function isEscapeEvent(e) {
    return e.which === 27 || e.keyCode === 27;
}

/**
 *
 * @param {number} epochSeconds
 * @param {Texter} texter
 * @returns {string|null}
 */
export function formatDuration(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) {
            return null;
        }

        const days = diff / DAY_SECONDS;
        if (days > MONTH_DAYS) {
            const months = (days / MONTH_DAYS);
            return Numbers.toMaxDecimals(months, 1) + texter.get('packMemo.short.months');
        }

        if (days > 1) {
            return Numbers.toMaxDecimals(days, 1) + texter.get('packMemo.short.days');
        }

        const hours = diff / HOUR_SECONDS;
        return Numbers.toMaxDecimals(hours, 1) + texter.get('packMemo.short.hours');
    }
    return null;
}

/**
 *
 * @param {number} epochSeconds
 * @param {Texter} texter
 * @returns {string|null}
 */
export function formatHumanDayPeriod(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) {
            return null;
        }

        const days = Math.ceil(diff / DAY_SECONDS);
        return texter.get('pl.days', days);
    }
    return null;
}

export function clickOn(jqEl) {
    if (jqEl.length) {
        jqEl
            .focus()
            .click();
    }
}

export function callLater(callback) {
    setTimeout(callback, 1);
}

let USER_TZ = null;

export function userTz() {
    if (USER_TZ == null && 'Intl' in window && 'DateTimeFormat' in Intl) {
        const formatter = new Intl.DateTimeFormat();
        if ('resolvedOptions' in formatter) {
            const options = formatter.resolvedOptions();
            if ('timeZone' in options) {
                USER_TZ = options.timeZone;
            }
        }
    }
    return USER_TZ;
}

export function cardTextOnly(cardText, cardTextType) {
    if (cardTextType === 'html') {
        cardText = cardText
            .replace(/<\/p>/g, '\n')
            .replace(/<[^>]+>/g, '');
    }
    return cardText;
}